<template>
  <v-row>
    <v-container fluid class="section-height soft-grey">
      <v-row class="mt-7">
        <Header :value="'Контакты'"/>
      </v-row>
      <v-row class="d-flex flex-column title font-weight-light text-center px-10">
        <v-col>
          Вы можете позвонить или написать мне в любое время с 11.00 до 21.00
        </v-col>
        <v-col>
          Если я не отвечаю – оставьте сообщение, я обязательно свяжусь с Вами.
        </v-col>
        <v-col>
          Телеграм: @yudina_maria_psy
        </v-col>
        <v-col>
          Телефон: 8-916-053-24-93
        </v-col>
        <v-col>
          Почта yudina_maria.psy@mail.ru
        </v-col>
        <v-col>
          Телеграмм-канал: <a>t.me/psychology_chair</a>
        </v-col>
      </v-row>
      <v-row>
        <Header :value="'Как добраться'"/>
      </v-row>
      <v-row class="d-flex flex-column title font-weight-light text-center px-10">
        <v-col cols="12">
          Центр "Частная практика" расположен в 3 минутах ходьбы от станций метро Библиотека им. Ленина, Боровицкая
        </v-col>
        <v-col cols="12">
          и в 5 минутах ходьбы от станций метро Арбатская Арбатско-покровской и Филевской линий.
        </v-col>
      </v-row>
      <v-row>
        <Header :value="'Адрес кабинета'"/>
      </v-row>
      <v-row class="d-flex flex-column title font-weight-light text-center px-10">
        <v-col>
          Москва, Староваганьковский переулок, д.19с7. 1 подъезд, 3 этаж.
        </v-col>
        <v-col>
          На домофоне нужно нажать кнопку с нашим логотипом. На 3 этаже наша дверь первая справа.
        </v-col>
        <v-col>
          <iframe
            src="https://yandex.com/map-widget/v1/?um=constructor%3Ab24a207cfe26b36b87b6d70054a052ad814917186091e4635394453f373cceae&amp;source=constructor"
            :width="$vuetify.breakpoint.smAndDown ? 'auto' : 560"
            :height="$vuetify.breakpoint.smAndDown ? 'auto' : 470"
            frameborder="0"
          >
          </iframe>
        </v-col>
      </v-row>
    </v-container>
  </v-row>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "Contacts",
  components: { Header },
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>
